import tw, { styled } from 'twin.macro';

import { Stack } from '../../Stack/Stack';

export const StyledHeader = styled.header<{ borderless: boolean }>`
	${tw`bg-white sticky top-0 z-20 border-gray-200 print:hidden`};
	${(props) => !props.borderless && tw`border-b`};
`;

export const StyledMinimalHeader = styled.header<{ borderless: boolean }>`
	${tw`bg-white sticky top-0 border-gray-200 px-6 py-4 gap-4 flex justify-between items-center flex-wrap z-20 print:hidden`};
	${(props) => !props.borderless && tw`border-b`};
`;

export const StyledHeaderContent = styled(Stack)<{ responsive: boolean }>`
	${tw`gap-4 px-4 sm:px-6 py-4`}
	${(props) =>
		props.responsive
			? tw`flex-col lg:flex-row items-start lg:items-center sm:justify-between`
			: tw`flex-row justify-between`}
`;
